var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotRelevantEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeInherit",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54 14.25L3.96 17.19L5.04 11L0.5 6.56L6.75 5.66L9.54 3.8147e-06L12.33 5.66L18.57 6.56L14.04 11L15.1 17.22L9.54 14.25Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19C7.62108 19 5.78435 18.4428 4.22209 17.399C2.65982 16.3551 1.44218 14.8714 0.723149 13.1355C0.00411618 11.3996 -0.184015 9.48947 0.182544 7.64665C0.549104 5.80383 1.45389 4.11109 2.78249 2.78249C4.11109 1.45389 5.80383 0.549104 7.64665 0.182544C9.48947 -0.184015 11.3996 0.00411618 13.1355 0.723149C14.8714 1.44218 16.3551 2.65982 17.399 4.22209C18.4428 5.78435 19 7.62108 19 9.5C18.9974 12.0187 17.9956 14.4336 16.2146 16.2146C14.4336 17.9956 12.0187 18.9974 9.5 19ZM9.5 1.3C7.8782 1.3 6.29281 1.78093 4.94433 2.68195C3.59585 3.58298 2.54483 4.86365 1.92419 6.362C1.30355 7.86035 1.14117 9.5091 1.45756 11.0997C1.77396 12.6904 2.55494 14.1515 3.70173 15.2983C4.84852 16.4451 6.30962 17.226 7.90026 17.5424C9.49091 17.8588 11.1397 17.6965 12.638 17.0758C14.1364 16.4552 15.417 15.4042 16.3181 14.0557C17.2191 12.7072 17.7 11.1218 17.7 9.5C17.6974 7.32604 16.8326 5.24188 15.2954 3.70465C13.7581 2.16743 11.674 1.30265 9.5 1.3Z",
    fill: "#656565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7309 3L3 14.7309L4.06066 15.7916L15.7916 4.06066L14.7309 3Z",
    fill: "#656565"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRelevantEmpty);
export default __webpack_public_path__ + "static/media/not-relevant-empty.87fac1bad62e90bd2edc51234904ca76.svg";
export { ForwardRef as ReactComponent };